export enum EarthDayTextureQuality {
  POTATO = '512',
  LOW = '1k',
  MEDIUM = '2k',
  HIGH = '4k',
  ULTRA = '16k',
}

export enum EarthNightTextureQuality {
  POTATO = '512',
  LOW = '1k',
  MEDIUM = '2k',
  HIGH = '4k',
  ULTRA = '16k',
}

export enum EarthSpecTextureQuality {
  OFF = 'off',
  POTATO = '256',
  LOW = '1k',
  MEDIUM = '2k',
  HIGH = '4k',
  ULTRA = '8k',
}

export enum EarthBumpTextureQuality {
  OFF = 'off',
  LOW = '256',
  MEDIUM = '4k',
  HIGH = '8k',
}

export enum EarthCloudTextureQuality {
  OFF = 'off',
  POTATO = '512',
  LOW = '1k',
  MEDIUM = '2k',
  HIGH = '4k',
  ULTRA = '8k',
}

export enum EarthPoliticalTextureQuality {
  OFF = 'off',
  POTATO = '1k',
  LOW = '2K',
  MEDIUM = '4k',
  HIGH = '8k',
  ULTRA = '16k',
}

export enum EarthTextureStyle {
  BLUE_MARBLE = 'earthmap',
  NADIR = 'earthmapalt',
  FLAT = 'flat',
}

export enum AtmosphereSettings {
  OFF = 0,
  ON = 1,
}
